<template>
    <div>
        <Section>
            <div class="top-describe">
                <div class="describe-left">
                    <div class="des-top">
                        <b>{{title}}</b>
                        <div class="des-state" v-if="!isOpen">
                            <Icon type="md-close-circle" :size="18" color="red"/>
                            已关闭
                            <span>即用户端已隐藏该功能，后台数据无影响，可在右侧开启</span>
                        </div>
                        <div class="des-state-open" v-if="isOpen">
                            <Icon type="md-checkmark-circle" :size="18" :color="openColor"/>
                            已开启
                            <span>即用户端已显示该功能，可在右侧关闭</span>
                        </div>
                        
                    </div>
                    <div class="des-bom">{{remark}}</div>
                </div>
                <div class="describe-right">
                    <Button v-if="!isOpen" type="success" @click="Open">开启功能</Button>
                    <Button v-if="isOpen" class="close" @click="Close">关闭功能</Button>
                </div>
            </div>
        </Section>
        <Section>
                <div>
                    <FilterBox :item-right="40" inline style="padding: 20px;">
                        <FilterBoxItem>
                            <Input v-model="filterName" clearable style="width: 250px" @input="searchName" placeholder='POI名称/POIID/活动标题/活动提交人'/>
                        </FilterBoxItem>

                        <FilterBoxItem>
                            <Select v-model="defaultType"  @on-change="changeType">
                                <Option value="0">POI分类类型-全部</Option>
                                <Option v-for="item in poiTypes" :value="item">{{item}}</Option>
                            </Select>
                        </FilterBoxItem>

                         <FilterBoxItem>
                            <Select  v-model="defaultFloor" @on-change="changeFloor">
                                <Option value="0">
                                    所属楼层-全部
                                </Option>
                                <Option v-for="item in floors" :value="item.floorName">{{item.floorName}}</Option>
                            </Select>
                        </FilterBoxItem>

                        <FilterBoxItem>
                            <Select v-model="selState" @on-change="stateSearch">
                                <Option value="0">活动状态-全部</Option>
                                <Option value="待开启">待开启</Option>
                                <Option value="进行中">进行中</Option>
                                <Option value="已结束">已结束</Option>
                                <Option value="已下线">已下线</Option>
                            </Select>
                        </FilterBoxItem>

                        <FilterBoxItem>
                            <div class="clear-search" @click="clearSearch">
                                <Icon style="vertical-align:top" type="md-close-circle" :size="18" color="#bfbfbf"/>
                                <span>清空筛选</span>
                            </div>
                        </FilterBoxItem>
                    </FilterBox>
                </div>
                <div class="middel-mid">
                    <div class="left">
                        <span><b>{{title}}</b></span>
                             <span class="colorA3 ml-5px">(共<b style="color: #3384f7">{{data2.length}}</b>条，已筛选<b style="color: #3384f7">{{filtrateNumber}}</b>条)</span>
                    </div>       
                </div>
                <div class="middel-mid">
                    <div class="left">
                        <span class="colorA3 ml-5px mr-10px">全选(已选<b style="color: #3384f7">{{ids.length}}</b>条)</span>
                        <Button v-show="!btnActive" disabled type="default">清空活动内容</Button>
                        <Button v-show="btnActive" type="error" @click="delModel = true">清空活动内容</Button>
                    </div>        
                </div>
                <div style="padding: 0 20px 20px">
                <Table border :columns="columns" :data="nowData" @on-selection-change="selTable"></Table>
                <Page :total="dataCount" :page-size="pageSize" on-page-size-change="_nowPageSize" @on-change="changepage" style="text-align: right; margin-top: 20px"></Page>
            </div>
        </Section>
        <Section>
            <Modal v-model="delModel" width="400">
                <div slot="header" class="modelHeader">
                   <i class="iconfont icon-gantanhao"></i>
                   <span>清空确认</span>
                </div>
                <div class="model-body">
                   <P>清空后，活动数据将<span>全部删除</span>！</P>
                   <p>是否继续<span>删除</span>?</p>
                </div>
                <div slot="footer" class="model-footer">
                   <button class="cancel" @click="delModel = false">取消</button>
                   <Button type="error" @click="delSure">确认删除</Button>
               </div>
            </Modal>
             <Modal v-model="downModel" width="400">
                <div slot="header" class="modelHeader">
                   <i class="iconfont icon-gantanhao"></i>
                   <span>下线确认</span>
                </div>
                <div class="model-body">
                   <P>下线后，该活动用户端不可见</P>
                   <p>是否继续<span>下线</span>?</p>
                </div>
                <div slot="footer" class="model-footer">
                   <button class="cancel" @click="downModel = false">取消</button>
                   <Button type="error" @click="downSure">确认下线</Button>
               </div>
            </Modal>
            <Modal
                v-model="upModel" :width="400">
               <div slot="header" class="modelHeader">
                   <span style="color:#3384f7">上限确认</span>
               </div>
               <div class="model-body">
                   <P>上线后，该活动用户端将可见</P>
                   <p>是否继续<span style="color:#3384f7">上线</span>?</p>
               </div>
               <div slot="footer" class="model-footer">
                   <button class="cancel" @click="upModel = false">取消</button>
                   <Button type="primary" @click="upSure">确认上线</Button>
               </div>
            </Modal>
        </Section>
    </div>
</template>

<script>
    import LabelHeader from '@/modules/LabelHeader';

    import menuUtil from '../../../utils/menu-list.js';

    import FilterBox from '@/modules/FilterBox';

    import FilterBoxItem from '@/modules/FilterBoxItem';

    import { Button,RadioGroup,Radio,Input,Table,Page, Select,Option,Modal,Icon} from 'iview';
    import qs from 'qs';
    import Request from '../../../utils/request';
    import DATE from '../../../utils/util';
export default {
    props: {

    },
    data() {
        return {
            title:'',
            remark:'',
            saveBtn:false,
            btnActive:false,
            openColor:'#19be6b',
            filterName:'',
            dataAll:[],//所有数据
            dataCount:0,//数据总条数
            pageSize:10,//每页数据条数
            actStores:[],// 存放活动店铺数据
            pageCurrent: 1,//当前页
            downModel: false,//下线弹窗
            upModel:false,//上线弹窗
            otherDataAll:'',
            poiTypes:[],//所有poi分类
            selState:'0',//活动状态默认0
            defaultType:'0',//poi默认分类0
            defaultFloor:'0',//默认楼层0 全部
            filtrateNumber:0,
            floors:[],//楼层
            delModel:false,
            isOpen:false,
            ids:[],
            upId:'',
            downId:'',
            nowData:[],
            nowData2:'',
            columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        maxWidth:100
                    },
                    {
                        title: '序号',
                        key: 'number',
                        align: 'center',
                        width:80
                    },
                    {
                        title: 'POI名称',
                        key: 'poiName',
                        align: 'center',
                        width: 130
                    },
                    {
                        title: 'POI分类类型',
                        key: 'poiType',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: 'POIID',
                        key: 'poiId',
                        align: 'center',
                        ellipsis: true,
                        minWidth: 60
                        
                    },
                    {
                        title: '所属楼层',
                        key: 'site',
                        align: 'center',
                        minWidth:50
                        
                    },
                    {
                        title: '店铺活动标题',
                        key: 'actName',
                        align: 'center',
                        minWidth:180
                        
                    },
                    {
                        title: '活动提交人',
                        key: 'actPersion',
                        align: 'center',
                        minWidth: 100
                        
                    },
                    {
                        title: '活动更新时间',
                        key: 'actTime',
                        align: 'center',
                        minWidth:100
                        
                    },
                    {
                        title: '店铺活动状态',
                        key: 'status',
                        align: 'center',
                        minWidth:80,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth: 130,
                        render: (h, params) => {

                            let btnStyle = {
                                padding: '0 10px'
                            };
                            if(params.row.status == ''){
                                return h('div', [
                                    h('a', {style: btnStyle,on:{click:() =>{
                                        this.$emit('listListen','details',params.row)
                                    }}}, '添加活动'),   
                                ]);
                            }
                            else if(params.row.status == '待开启'){
                                 return h('div', [
                                    h('a', {style: btnStyle,on:{click:() =>{
                                        this.$emit('listListen','details',params.row)
                                    }}}, '查看活动'),
                                    h('a', {style: btnStyle,on:{
                                        click:()=>{
                                            this.downActivity(params.row.activityId)
                                        }
                                    }}, '下线活动'),
                                ]);
                            }
                            else if(params.row.status == '进行中'){
                                return h('div', [
                                    h('a', {style: btnStyle,on:{click:() =>{
                                        console.log(params)
                                        this.$emit('listListen','details',params.row)
                                    }}}, '查看活动'),
                                    h('a', {style: btnStyle,on:{
                                        click:()=>{
                                            this.downActivity(params.row.activityId)
                                        }
                                    }}, '下线活动'),
                                ]);
                            }
                            else if(params.row.status == '已结束'){
                                return h('div', [
                                    h('a', {style: btnStyle,on:{click:() =>{
                                        this.$emit('listListen','details',params.row)
                                    }}}, '查看活动'),
                                ]);
                            }
                            else if(params.row.status == '已下线'){
                                 return h('div', [
                                    h('a', {style: btnStyle,on:{click:() =>{
                                        this.$emit('listListen','details',params.row)
                                    }}}, '查看活动'),
                                    h('a', {style: btnStyle,on:{
                                        click:()=>{
                                            this.upActivity(params.row.activityId)
                                        }
                                    }}, '上线活动'),
                                ]);
                            }
                           
                        }
                    }
             ],
            data2:[],
           
        };
    },
    
   mounted(){
       let menuObj = menuUtil.getRemark(this.$router.history.current.path);
            this.title = menuObj.menuName;
            this.remark = menuObj.remark;
   },
   components:{
       LabelHeader,
       menuUtil,
       Button,
       Input,
       Select,
       Option,
       FilterBox,
       FilterBoxItem,
       Table,
       Page,
       Modal,
       Icon
   },
   methods:{
       //POI名称模糊搜索
       searchName(val){
           let type = this.defaultType;           
           let floor = this.defaultFloor
           let state = this.selState;
           let searchNowData = this.data2.filter(item =>{
                  return item.poiName.indexOf(val) > -1 || item.poiId.indexOf(val) > -1 || item.actName.indexOf(val) > -1 || item.actPersion.indexOf(val) > -1
                })
                if(type != '0'){
                    searchNowData = searchNowData.filter(item =>{
                        return item.poiType.indexOf(type) > -1
                    })
                }
                if(floor != '0' ){
                    searchNowData = searchNowData.filter(item =>{
                        return item.site.indexOf(floor) > -1
                    })
                }
                if(state != '0'){
                    searchNowData = searchNowData.filter(item =>{
                        return item.status.indexOf(state) > -1
                    })
                }
                this.dataCount = searchNowData.length;
                this.filtrateNumber = this.dataCount;
                this.nowData = searchNowData.slice(0,this.pageSize);
                this.otherDataAll = searchNowData;
                if(val == ''){
                    console.log(1)
                    this.filtrateNumber = 0;
                }
       },
       
       changeType(option){
            let name = this.filterName;           
            let floor = this.defaultFloor
            let state = this.selState;
            let searchNowData = this.data2.filter(item =>{
                return item.poiName.indexOf(name) > -1 || item.poiId.indexOf(name) > -1 || item.actName.indexOf(name) > -1 || item.actPersion.indexOf(name) > -1
            })
            if(option == '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.poiType.indexOf(option) == -1
                })
            }
            else{
                searchNowData = searchNowData.filter(item =>{
                    return item.poiType.indexOf(option) > -1
                })
            }

            if(floor != '0' ){
                searchNowData = searchNowData.filter(item =>{
                    return item.site.indexOf(floor) > -1
                })
            }
            if(state != '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.status.indexOf(state) > -1
                })
            }
            this.dataCount = searchNowData.length;
            this.filtrateNumber = searchNowData.length;
            this.nowData = searchNowData.slice(0,this.pageSize);
            this.otherDataAll = searchNowData;
         
        },
        changeFloor(option){
            let name = this.filterName;  
            let type = this.defaultType;           
            let state = this.selState;
            let searchNowData = this.data2.filter(item =>{
                return item.poiName.indexOf(name) > -1 || item.poiId.indexOf(name) > -1 || item.actName.indexOf(name) > -1 || item.actPersion.indexOf(name) > -1
            })

            if(type != '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.poiType.indexOf(type) > -1
                })
            }

            if(option == '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.site.indexOf(option) == -1
                })
            }
            else{
                searchNowData = searchNowData.filter(item =>{
                    return item.site.indexOf(option) > -1
                })
            }

            if(state != '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.status.indexOf(state) > -1
                })
            }  
            this.dataCount = searchNowData.length;
            this.filtrateNumber = this.dataCount;
            this.nowData = searchNowData.slice(0,this.pageSize);
            this.otherDataAll = searchNowData;
        },
        //状态筛选
       stateSearch(option){
            let name = this.filterName;           
            let type = this.defaultType; 
            let floor = this.defaultFloor
            let searchNowData = this.data2.filter(item =>{
                return item.poiName.indexOf(name) > -1 || item.poiId.indexOf(name) > -1 || item.actName.indexOf(name) > -1 || item.actPersion.indexOf(name) > -1
            })
            if(type != '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.poiType.indexOf(type) > -1
                })
            }
            if(floor != '0' ){
                searchNowData = searchNowData.filter(item =>{
                    return item.site.indexOf(floor) > -1
                })
            }

            if(option == '0'){
                searchNowData = searchNowData.filter(item =>{
                    return item.status.indexOf(option) == -1
                })
            }
            else{
                searchNowData = searchNowData.filter(item =>{
                    return item.status.indexOf(option) > -1
                })
            }         
            this.dataCount = searchNowData.length;
            this.filtrateNumber = this.dataCount;
            this.nowData = searchNowData.slice(0,this.pageSize);
            this.otherDataAll = searchNowData;
            
       },
       //清空筛选
       clearSearch(){
            this.filterName = '',
            this.selState = '0';
            this.defaultType ='0';
            this.defaultFloor = '0';
            this.searchName('');
       },
       //开启功能
       Open(){
           Request.post(`${this.$HOST}/back/setting/open/poiActivity?buildingId=${this.$route.params.buildingId}`)
           .then(response =>{
               if(response.data.code == 0){
                   this.$Message.success('开启成功');
                   this.isOpen = true;
               }
              
           })
           .catch(()=>{
               this.$Message.error('开启失败，请稍后再试')
           })
       },

        //关闭功能
        Close(){
            Request.post(`${this.$HOST}/back/setting/close/poiActivity?buildingId=${this.$route.params.buildingId}`)
            .then(response =>{
                if(response.data.code == 0){
                    this.$Message.success('关闭成功');
                    this.isOpen = false;
                }
                
            })
            .catch(()=>{
                this.$Message.error('关闭失败，请稍后再试')
            })
        },
       //表格 勾选
       selTable(selection){
           this.ids.length = 0;
           if(selection.length > 0){
                for(let i = 0 ; i < selection.length ; i++){
                    if(selection[i].activityId !=''){
                        this.btnActive = true;
                        this.ids.push(selection[i].activityId)
                    }
                    else{
                        this.btnActive = false;
                    }
                }
            }
            else{
                this.btnActive = false
            }
            console.log(this.ids)
           //poiActIds
       },
       //删除活动
       delSure(){
           Request.delete(`${this.$HOST}/back/poiActivity?buildingId=${this.$route.params.buildingId}`,
            {params:{ids:this.ids},paramsSerializer: params =>{return qs.stringify(params,{indices:false})}}
           )
           .then(response =>{
               if(response.data.code == 0){
                   this.delModel = false;
                   this.$Message.success('删除成功');
                   this.searchList();
                   this.btnActive = false;

               }
           })
           .catch(() =>{
               this.$Message.error('删除失败，请稍后再试')
           })
       },
       //下线活动
       downActivity(id){
           this.downId = id
           this.downModel = true;
       },
        //下线请求
        downSure(){
            Request.post(`${this.$HOST}/back/poiActivity/offLine/${this.downId}?buildingId=${this.$route.params.buildingId}`,{})
            .then(response =>{
                if(response.data.code == 0){
                    this.downModel = false;
                    this.searchList();
                    this.$Message.success('确认下线成功');
                }

            })
            .catch(()=>{
                this.$Message.error('确认下线失败，请稍后再试');
            })
        },
        //上线活动
        upActivity(id){
            this.upId = id;
            this.upModel= true;
        },
        //上线活动 请求
        upSure(){
            Request.post(`${this.$HOST}/back/poiActivity/onLine/${this.upId}?buildingId=${this.$route.params.buildingId}`,{})
            .then(response =>{
                if(response.data.code == 0){
                    this.upModel = false;
                    this.searchList();
                    this.$Message.success('确认上线成功');
                }

            })
            .catch(()=>{
                this.$Message.error('确认上线失败，请稍后再试');
            })
        },
        //查询
        searchList(){
            this.data2 = [];
            this.nowData = [];
            this.otherDataAll = '';
            this.actStores = [];
            let POI;
            if(sessionStorage.getItem('POI') != null){
                let poi = JSON.parse(sessionStorage.getItem('POI'));
                POI = poi.filter(item =>{
                    return item.n !=''
                })
            }

            let POILIST = JSON.parse(sessionStorage.getItem('POI_list'));            
            let threePoi = [];
            for(let i = 0 ; i < POILIST.length ; i++){
                for(let j = 0 ; j < POILIST[i].children.length ; j++){
                    for(let k = 0 ; k < POILIST[i].children[j].children.length ; k++){
                        threePoi.push({label:POILIST[i].children[j].children[k].label,id:POILIST[i].children[j].children[k].value})
                    }
                }
            }
            Request.get(`${this.$HOST}/back/poiActivity?buildingId=${this.$route.params.buildingId}`)
            .then(response =>{
                let open = response.data.data.open;
                open == 0 ? this.isOpen = false : this.isOpen = true;
                if(response.data.code == 0){
                    response.data.result.forEach(item =>{
                        let actObj = {
                                id:item.id,
                                poiId:item.poiId,
                                activeName:item.title,
                                actPerson:item.sysUserName,
                                activeTime:item.createdTime,
                                categoryId:item.categoryId,
                                floorId:item.floorId,
                                floorName:item.floorName,
                                floorNumber:item.floorNumber,
                                sysUserId:item.sysUserId,
                                status:item.status,
                                userId:item.userId,
                                startTime:item.startTime,
                                endTime:item.endTime,
                                imgUrl:item.activityImgUrl,
                                contentHtml:item.contentHtml

                        }
                        this.actStores.push(actObj);
                        
                        
                    })//拿到参与活动数据
  
                    let floor = [];//放所有楼层
                    let nowMin = new Date().getTime();
                    for(var i = 0 ; i < POI.length ; i++){
                        floor.push({floorName:POI[i].fn,floorId:POI[i].fi});
                        var obj = {
                            number:i+1,
                            poiName:POI[i].n,
                            poiType:'',
                            poiId:POI[i].i,
                            site:POI[i].fn, 
                            actName:'',
                            actPersion:'',
                            actTime:'',
                            status:'',
                            categoryId:'',
                            floorId:POI[i].fi,
                            floorName:POI[i].fn,
                            floorNumber:POI[i].f,
                            sysUserId:'',
                            status:'',
                            userId:'',
                            activityId:'',
                        }
                        for(var j = 0 ; j < this.actStores.length ; j++){
                            if(POI[i].i == this.actStores[j].poiId){
                                obj.activityId = this.actStores[j].id,
                                obj.actName = this.actStores[j].activeName;
                                obj.actPersion=this.actStores[j].actPerson;
                                obj.actTime=DATE.dateFormat(this.actStores[j].activeTime,'yyyy-MM-dd hh:mm:ss');
                                obj.status=this.actStores[j].status;
                                obj.categoryId=this.actStores[j].categoryId;
                                obj.sysUserId=this.actStores[j].sysUserId;
                                obj.status=this.actStores[j].status == 1 ? '已下线' : (nowMin - this.actStores[j].startTime > 0 && nowMin - this.actStores[j].endTime < 0 ? '进行中' :(nowMin - this.actStores[j].startTime < 0 ? '待开启':'已结束'));
                                obj.userId=this.actStores[j].userId;
                                obj.startTime = this.actStores[j].endTime;
                                obj.endTime = this.actStores[j].endTime;
                                obj.imgUrl = this.actStores[j].imgUrl;
                                obj.contentHtml = this.actStores[j].contentHtml;
                            }
                        }
                        for(let k = 0 ; k < threePoi.length ; k++){
  
                            if(threePoi[k].id == POI[i].c){
                                obj.poiType = threePoi[k].label
                            }
                        }
                        this.data2.push(obj)

                    } 
                    this.dataCount = this.data2.length;//总数据条数
                    this.nowData = this.data2.slice(0,this.pageSize);//第一页10条数据 
                    this.otherDataAll = this.data2
                    this.nowData2 = this.nowData;  

                     //所有poi分类去重
                    this.data2.forEach(item =>{
                        if(item.poiType != ''){
                            this.poiTypes.includes(item.poiType)? '':this.poiTypes.push(item.poiType)
                        }
                    })
                     //楼层去重
                    let aryObj = {};
                    for(let i = 0 ; i < floor.length ; i++){
                        if(!aryObj[floor[i].floorId]){
                            this.floors.push(floor[i]);
                            aryObj[floor[i].floorId] = true
                        }
                    }
                }
                
            })
            .catch(err =>{
                this.$Message.error(err);
            })
        },

    //点击分页
    changepage(index){
        //需要显示开始数据的index,(因为数据是从0开始的，页码是从1开始的，需要-1)
        let _start = (index - 1) * this.pageSize;
        //需要显示结束数据的index
        let _end = index * this.pageSize;
        //截取需要显示的数据
        this.nowData = this.otherDataAll.slice(_start, _end);
       // this.nowData2 = this.nowData
        //储存当前页
        this.pageCurrent = index;
    },
    _nowPageSize(index) {
        //实时获取当前需要显示的条数
        this.pageSize = index;
    },
   },
   created(){
        //查询
        this.searchList();  
   }

};
</script>

<style scoped lang="less">
    @import '../../../styles/comm';
    @import '../../../styles/mainTop';
    .middel-mid{
        background-color: #ffffff;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        border-top: 1px solid #e3e8ee;
        .left{
            float: left;
        }
        .right{
            float: right;
        }
    }
    .clear-search{
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        vertical-align: middle;
        i{
            display: inline-block;
            line-height: 30px;
        }
        span{
            vertical-align: middle;
            margin-left: 3px;
        }
    }
</style>
